// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"8524675f","172":"8524675f"}[chunkId] + ".chunk.css";
};